import React from 'react';

import { avatarColor, avatarInitial } from '../../format';
import { Disc, Initial } from './PlayerAvatar.styles';

export type PlayerAvatarProps = {
  /** Drives BOTH the glyph (first letter) and the deterministic disc colour. */
  email: string;
  /** Diameter in px (the glyph scales with it). Defaults to 40. */
  size?: number;
  className?: string;
};

/**
 * The initial-in-a-circle avatar shown beside a player's email. The disc colour
 * is a deterministic hash of the email into the shared palette, so a given
 * address always renders the same colour. Decorative (`aria-hidden`) — the email
 * sits right next to it.
 */
export const PlayerAvatar = ({ email, size = 40, className }: PlayerAvatarProps): React.ReactElement => {
  const { bg, fg } = avatarColor(email);
  return (
    <Disc className={className} $bg={bg} $size={size} aria-hidden="true">
      <Initial text={avatarInitial(email)} tag="span" $fg={fg} $size={size} />
    </Disc>
  );
};

export default PlayerAvatar;
